import { styled } from "@linaria/react";

import { withTheme } from "../theme/GalaxyTheme";
import type { PropsWithTheme } from "../theme/types";

import GalaxyLogomark from "../icons/GalaxyLogomark";
import AvatarShimmer from "./AvatarShimmer";

export interface GalaxyAvatarProps {
  isLoading?: boolean;
  size?: number;
}

const StyledGalaxyAvatar = withTheme(styled.div<
  PropsWithTheme<{
    $size: number;
  }>
>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.color.background.tertiary};
  border: 0.5px solid ${({ theme }) => theme.color.border.primary};
  padding: ${({ $size }) => {
    // Calculate padding based on size: smaller sizes get less padding proportionally
    if ($size <= 16) return "2px";
    if ($size <= 24) return "3px";
    return "4px";
  }};
  height: ${({ $size }) => $size}px;
  width: ${({ $size }) => $size}px;
`);

const GalaxyAvatar = ({ isLoading, size = 16 }: GalaxyAvatarProps) => {
  if (isLoading) {
    return isLoading ? <AvatarShimmer size={size} /> : null;
  }

  // Scale the inner mark down so it feels balanced at all avatar sizes.
  const padding = size <= 16 ? 2 : size <= 24 ? 3 : 4;
  const availableInnerSize = size - padding * 2;
  const logoSize = Math.max(8, Math.round(availableInnerSize * 0.75));

  return (
    <StyledGalaxyAvatar $size={size}>
      <GalaxyLogomark height={logoSize} />
    </StyledGalaxyAvatar>
  );
};

export default GalaxyAvatar;
